import styled from "styled-components";

export const PickerRackModalWrapper = styled.div`
  .quantityWrapper {
    display: flex;
    flex-flow: column;
    gap: 0.5em;

    .quantityInfoWrapper {
      display: grid;
      width: 100%;
      grid-template-columns: repeat(2, auto);
      gap: 10px;

      label {
        font-size: medium;
        color: var(--dark-light);
        font-weight: 400;
        margin: 0;
      }

      p {
        font-weight: 600;
        font-size: medium;
        color: var(--dark);
        margin: 0;
      }

      p.active {
        color: var(--accent);
      }
    }

    .flexDiv {
      display: flex;
      flex-flow: row nowrap;
      gap: 10px;

      .bbtn {
        width: max-content;
      }
    }
  }
`;

export const RackPickDone = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2em;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    background: var(--green--light);
    padding: 0.5em 1.5em;
    border-radius: 5px;
    color: #0a6d41;
    font-weight: 600;
    border: 1px solid #95ffd0;

    svg {
      font-size: 18px;
    }
  }
`;
